import PropTypes from 'prop-types';
import React from 'react';
import { Col } from 'react-bootstrap';

function CardItem({ item, index }) {
  return (
    <div style={{ borderTop: '1px solid rgba(112, 112, 112, 0.32)' }} className="mt-2 pb-4">
      <div className="text-size-sm text-muted font-weight-normal order-1 mb-1" aria-label={item.title}>
        {`0${index + 1}`}
      </div>
      <Col xs={12} className="order-3 m-0 p-0 pb-3">
        <h3 className="h6 font-weight-bold text-transform-none letter-spacing-normal">{item.title}</h3>
      </Col>

      <div className="text-muted" dangerouslySetInnerHTML={{ __html: item.description }} />
    </div>
  );
}

CardItem.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
  index: PropTypes.number.isRequired,
};

export default CardItem;
